import { format } from 'date-fns';

const NOTICE_HIDDEN_TODAY_KEY = 'NOTICE_HIDDEN_TODAY';

export const getHiddenNoticeIdsForToday = (): number[] => {
    try {
        const stored = localStorage.getItem(NOTICE_HIDDEN_TODAY_KEY);
        if (!stored) return [];
        const data = JSON.parse(stored);
        const today = format(new Date(), 'yyyy-MM-dd');
        if (data.date === today) return data.noticeIds || [];
        localStorage.removeItem(NOTICE_HIDDEN_TODAY_KEY);
        return [];
    } catch {
        return [];
    }
};

export const saveHiddenNoticeForToday = (noticeId: number): void => {
    try {
        const today = format(new Date(), 'yyyy-MM-dd');
        const existingIds = getHiddenNoticeIdsForToday();
        if (!existingIds.includes(noticeId)) existingIds.push(noticeId);
        localStorage.setItem(NOTICE_HIDDEN_TODAY_KEY, JSON.stringify({ date: today, noticeIds: existingIds }));
    } catch (error) {
        console.error('오늘 하루 보지 않기 저장 실패:', error);
    }
};
